import React, {Component} from "react"

import {Icon, CustomIcon} from "~/components/"

export default class IconLabel extends Component {
  render() {
    let DynamicIcon = this.props.i.startsWith("/") ? CustomIcon : Icon
    return (
      <div className="sh-icon-label">
        <DynamicIcon i={this.props.i} />
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/decorators/IconLabel.js